export const DATA_TYPE_LINK = "link";
export const DATA_TYPE_TEXT = "text";
export const DATA_TYPE_IMAGE = "image";
export const IMAGE_BASE64 = "image_base64";
export const IMAGE_LINK = "image_link";
